export var jumboLayers = [{
  id: 'Jumbo',
  type: 'impressions',
  name: 'jumbo',
  model: 'jumbo',
  action: 'impression',
  modelize: function modelize(_ref) {
    var models = _ref.models;
    return models;
  },
  event: true
}, {
  id: 'Jumbo',
  type: 'click',
  action: 'clickCTA',
  name: 'jumbo',
  model: 'cta',
  event: true,
  modelize: function modelize(params) {
    return params;
  }
}];